import { Injectable } from "@angular/core";
import { formatDate } from "@angular/common";
import { AwsService } from "../../providers/appsyncservice/aws.service";

@Injectable({
  providedIn: "root",
})
export class DateutilService {
  holidaylist = [];

  constructor(private aws: AwsService) {
    this.getHolidayList();
  }
  getNumberOfWorkingDays(fromDate: Date, toDate: Date): number {
    var wokringDays = 0;
    if (this.holidaylist.length == 0) this.getHolidayList();
    console.log("holidaylist", this.holidaylist);
    var from = new Date(formatDate(fromDate, "yyyy-MM-dd", "en"));
    var to = new Date(formatDate(toDate, "yyyy-MM-dd", "en"));
    if (from <= to) {
      from.setDate(from.getDate() + 1);
      for (var day = from; day <= to; day.setDate(day.getDate() + 1)) {
        if (
          day.getDay() != 0 &&
          day.getDay() != 6 &&
          this.holidaylist.indexOf(day.getTime()) < 0
        )
          wokringDays++;
      }
    } else {
      //   from.setDate(from.getDate()-1)
      for (var day = from; day > to; day.setDate(day.getDate() - 1)) {
        if (
          day.getDay() != 0 &&
          day.getDay() != 6 &&
          this.holidaylist.indexOf(day.getTime()) < 0
        )
          wokringDays--;
      }
    }

    return wokringDays;
  }

  getNextWorkingDayFrom(days: number): Date {
    var wokringDays = 0;
    var day = new Date();
    if (this.holidaylist.length == 0) this.getHolidayList();
    console.log("holidaylist", this.holidaylist);
    day = new Date(formatDate(day, "yyyy-MM-dd", "en"));
    var i = 0;
    while (days > wokringDays) {
      day.setDate(day.getDate() + 1);
      console.log("nextWorkingDay", day, day.getDay());

      if (
        day.getDay() != 0 &&
        day.getDay() != 6 &&
        this.holidaylist.indexOf(day.getTime()) < 0
      )
        wokringDays++;

      i++;
    }

    return day;
  }

  getHolidayList() {
    this.aws
      .getMiscData("HOLIDAY_LIST")
      .then((res) => {
        console.log("getHolidayList", JSON.parse(res[0].data_value));
        this.setHolidayList(JSON.parse(res[0].data_value));
      })
      .catch((err) => {
        console.log("getHolidayList-err", err);
      });
  }

  setHolidayList(data) {
    var list = [];
    for (var rs of data) {
      list.push(new Date(rs.date).getTime());
    }
    this.holidaylist = list;
    console.log("setHolidayList", this.holidaylist);
  }
}
